export type ProxySettingValueKind = 'text' | 'password' | 'integer';

export type ProxyIntegerBounds = {
  min?: number;
  max?: number;
};

export type ProxyIntegerDraftResult =
  | { valid: true; value: number }
  | { valid: false };

export type ProxySettingDisplayValue =
  | { kind: 'value'; text: string }
  | { kind: 'masked' }
  | { kind: 'notSet' };

export const toProxySettingDisplayValue = ({
  kind,
  value,
}: {
  kind: ProxySettingValueKind;
  value: string | number;
}): ProxySettingDisplayValue => {
  const text = String(value).trim();

  if (!text) {
    return { kind: 'notSet' };
  }

  return kind === 'password' ? { kind: 'masked' } : { kind: 'value', text };
};

export const parseProxyIntegerDraft = ({
  draft,
  min,
  max,
}: { draft: string } & ProxyIntegerBounds): ProxyIntegerDraftResult => {
  const trimmed = draft.trim();

  if (!/^-?\d+$/.test(trimmed)) {
    return { valid: false };
  }

  const value = Number.parseInt(trimmed, 10);
  const belowMin = min !== undefined && value < min;
  const aboveMax = max !== undefined && value > max;

  return belowMin || aboveMax ? { valid: false } : { valid: true, value };
};
